'use strict';

var GridMappedFaresFilterFactory = function GridMappedFaresFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FaresFilterByMarketFactory', 'FaresFilterByClassFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function GridMappedFaresFilter() {
    DemandFilter.call(this, 'mapped-fares-mode', 'mapped-fares');
    this.registerFilters(injectedFilters);
  }
  GridMappedFaresFilter.prototype = Object.create(DemandFilter.prototype);
  GridMappedFaresFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return GridMappedFaresFilter;
};
GridMappedFaresFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = GridMappedFaresFilterFactory;